//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { 
    Row, 
    TitleSection } from "components/styles";
//#endregion
//#region Components
import PageManager from "../../../components/PageManager/PageManager";
import CaptionGroup from "../../../components/CaptionGroup/CaptionGroup";
//#endregion
import { getWeekStringRange } from "components/CustomDatePicker/utils/helpers";

const Header = ({
    isCoordinator, 
    advisers,
    filterFields,
    dataPaginator
}) => {
    const { date } = filterFields;
    //#region States
    const [dateStr, setDateStr] = useState("-");
    //#endregion
    //#region Effects
    useEffect(() => {
        setDateStr(getWeekStringRange(new Date(date < 0 ? Date.now() : date), "-"));
    }, [date]);
    //#endregion
    const getAdviserName = () => {
        return advisers.find(({ code }) => code === filterFields.adviserCode)?.name || "-";
    }
    let title = `Semana del ${dateStr}`;
    if (isCoordinator)
        title += ` - ${getAdviserName()}`;
    return (
        <Row width="100%">
            <TitleSection 
                className="ellipsis"
                title={title}
                width="300px">
                {title}
            </TitleSection>
            <CaptionGroup/>
            <PageManager 
                caption="Semana"
                width="300px"
                dataPaginator={dataPaginator}/>
        </Row>
    );
}

export default Header;